module.exports = __webpack_public_path__ + "img/no-data.5a4bae71.svg";